<template>
    <div>
        <v-row class="white-card-background"
               style="height: 70vh;overflow: auto;">
            <v-col cols="12"
                   lg="5"
                   md="8"
                   sm="12">
                <v-sheet class="pa-3 rounded pb-9 security">
                    <div v-for="(item, index) in items"
                         :key="item.icon">
                        <v-sheet :class="{ selected: selectedComponent === index }"
                                 class="pa-3 rounded-lg mb-2 pointer "
                                 @click="showComponent(item, index)">
                            <v-avatar color="#E2F1FD"
                                      size="28">
                                <v-icon color="#006FCF"
                                        size="17">
                                    {{ item.icon }}
                                </v-icon>
                            </v-avatar>
                            <span class="font-weight-medium text-tab"
                                  style="font-size: 12px"
                                  :class="{
                                      'text-white': selectedComponent === index,
                                      'ml-2': selectedLanguage == 'en',
                                      'mr-2': selectedLanguage == 'ar',
                                  }">
                                {{ $t(item.text) }}
                            </span>
                            <v-icon v-if="selectedLanguage == 'en'"
                                    class="chevron-right"
                                    style="margin-top:3px"
                                    :class="{ selected: selectedComponent === index }">
                                {{ item.icon2 }}</v-icon>
                            <v-icon v-if="selectedLanguage == 'ar'"
                                    class="chevron-right"
                                    style="margin-top:3px"
                                    :class="{ selected: selectedComponent === index }">
                                {{ item.iconAr }}</v-icon>
                        </v-sheet>
                    </div>
                </v-sheet>
            </v-col>
            <v-col cols="12"
                   lg="7"
                   md="12"
                   sm="12">
                <v-row>
                    <v-col cols="12"
                           lg="4"
                           md="4"
                           sm="12">
                        <div style="display: flex;align-items: center;gap: 7px;">
                            <span><svg style="width: 20px;margin-bottom: -7px;"
                                     width="35"
                                     height="35"
                                     viewBox="0 0 35 35"
                                     fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M26.1039 34.2779C25.9729 34.2779 25.8409 34.2779 25.7039 34.2679C23.3423 34.0939 21.043 33.429 18.9529 32.3159C14.4265 30.1117 10.4185 26.9735 7.19293 23.1079C4.71724 20.2819 2.76475 17.0376 1.42694 13.5269C0.695806 11.7458 0.354817 9.82879 0.426939 7.90487C0.502056 6.51949 1.11151 5.21721 2.12701 4.27187C2.55201 3.86487 4.27295 2.1419 4.70795 1.7239C5.05265 1.36159 5.46773 1.07343 5.92767 0.877096C6.38761 0.680757 6.88278 0.580367 7.38287 0.582052C7.88296 0.583737 8.37739 0.687489 8.836 0.886923C9.2946 1.08636 9.70773 1.37728 10.05 1.7419C10.05 1.7419 13.7239 5.39587 14.1609 5.85787C14.548 6.1991 14.8576 6.6192 15.0689 7.08993C15.2803 7.56065 15.3885 8.07113 15.3863 8.58712C15.3841 9.10311 15.2717 9.61264 15.0563 10.0816C14.841 10.5505 14.5279 10.9679 14.138 11.3059C13.405 12.0719 12.629 12.8229 11.869 13.5529C12.3927 14.6415 13.0504 15.6605 13.827 16.5859C15.5567 18.7687 17.6277 20.6577 19.9599 22.1799C20.2649 22.3629 20.6299 22.5389 21.0169 22.7259L21.1319 22.7809C21.8739 22.0149 22.641 21.2459 23.409 20.4809C23.7519 20.1131 24.1668 19.8199 24.628 19.6193C25.0891 19.4188 25.5866 19.3153 26.0894 19.3153C26.5923 19.3153 27.0898 19.4188 27.551 19.6193C28.0121 19.8199 28.427 20.1131 28.77 20.4809C28.77 20.4809 31.981 23.6699 32.905 24.6189C33.2847 24.9617 33.5879 25.3805 33.7952 25.8481C34.0025 26.3158 34.1091 26.8218 34.1081 27.3333C34.1071 27.8449 33.9984 28.3505 33.7892 28.8173C33.5801 29.2841 33.2751 29.7016 32.894 30.0429C32.664 30.2729 32.4327 30.5006 32.2 30.7259C31.634 31.2779 31.0999 31.7989 30.6199 32.3499C30.057 32.9846 29.3607 33.4869 28.5807 33.8208C27.8008 34.1546 26.9567 34.3117 26.1089 34.2809L26.1039 34.2779ZM7.36993 2.96688C6.99375 2.99461 6.64304 3.16743 6.39191 3.44887C5.95091 3.87187 4.22893 5.59491 3.79193 6.01491C3.50552 6.2756 3.27339 6.59024 3.10882 6.94082C2.94426 7.2914 2.85051 7.671 2.83295 8.05788C2.7881 9.64742 3.08154 11.2283 3.69391 12.6959C4.92656 15.9461 6.73669 18.9467 9.03692 21.5529C12.0486 25.1631 15.7912 28.0942 20.018 30.1529C21.815 31.1185 23.7925 31.7011 25.826 31.8639C25.92 31.8639 26.0149 31.8699 26.1089 31.8699C26.6164 31.8994 27.1239 31.8139 27.5937 31.6198C28.0635 31.4257 28.4834 31.1279 28.822 30.7489C29.349 30.1419 29.9439 29.5609 30.5219 28.9989C30.7469 28.7799 30.9719 28.5599 31.1939 28.3379C31.352 28.2202 31.4804 28.0671 31.5688 27.891C31.6572 27.7148 31.7033 27.5205 31.7033 27.3234C31.7033 27.1263 31.6572 26.932 31.5688 26.7558C31.4804 26.5797 31.352 26.4266 31.1939 26.3089C30.2679 25.3579 29.3369 24.4339 28.4109 23.5159L27.07 22.1819C26.9549 22.0319 26.8067 21.9105 26.6371 21.8269C26.4676 21.7433 26.281 21.6997 26.092 21.6997C25.9029 21.6997 25.7164 21.7433 25.5468 21.8269C25.3772 21.9105 25.2291 22.0319 25.114 22.1819C24.259 23.0369 23.404 23.8929 22.586 24.7469C22.4224 24.9291 22.2235 25.0762 22.0014 25.1793C21.7793 25.2825 21.5387 25.3395 21.294 25.3469C21.0035 25.3435 20.718 25.2712 20.461 25.1359C20.2983 25.0539 20.1359 24.9746 19.9739 24.8979C19.5549 24.6979 19.122 24.4859 18.695 24.2299C16.1335 22.5655 13.8586 20.497 11.9589 18.1049C10.9479 16.9022 10.1165 15.5592 9.4909 14.1179C9.34181 13.7842 9.30021 13.4125 9.37189 13.0541C9.44356 12.6957 9.62497 12.3685 9.89093 12.1179C10.7449 11.2989 11.608 10.4709 12.419 9.62386C12.7298 9.35623 12.9274 8.98063 12.972 8.5729C12.9302 8.17346 12.739 7.80452 12.4369 7.53988C11.9969 7.07488 8.34894 3.4479 8.34894 3.4479C8.09744 3.16708 7.74686 2.99465 7.37091 2.96688"
                                          fill="#006FCF"></path>
                                </svg></span>
                            <b>{{ $t('Call Us') }}</b>
                        </div>

                    </v-col>
                    <v-col cols="12"
                           lg="8"
                           md="8"
                           sm="12">
                        <div v-if="selectedComponent === 0">
                            <div v-if="selectedLanguage === 'en'">
                                <p>From Saudi Arabia<br><strong><a href="tel:8001242229">800 124 2229</a></strong></p>

                                <p>From outside the Kingdom:<br><strong>
                                        <a href="tel:+966112926666">(+966) 11 292 6666</a></strong>
                                </p>

                                <p><strong>Working Hours:</strong><br><br>
                                    Customer Service:<br>
                                    8:00am - 8:00pm (All Week)<br><br>
                                    Front Offices<br>
                                    9:00am - 5:00pm (Sun - Thu)<br><br>
                                    Aramco Office-Midra<br>
                                    9:00am - 4:30pm (Sun - Thu)</p><br><br>
                            </div>
                            <div v-if="selectedLanguage === 'ar'">
                                <p>من السعودية<br><strong><span class="en-ar"><a href="tel:8001242229">2229 124
                                                800</a></span></strong></p>

                                <p>من خارج المملكة:<br><strong><span class="en-ar"><a href="tel:+966112926666">6666 292 11
                                                (966+)</a></span></strong></p>

                                <p><strong>ساعات العمل:</strong><br><br>
                                    خدمة العملاء:<br>
                                    8:00 صباحًا إلى 8:00 مساء (طوال أيام الأسبوع)<br><br>
                                    المكاتب الرئيسية:<br>
                                    9:00 صباحًا إلى 5:00 مساء (الأحد- الخميس)<br><br>
                                    مكتب المدرا- أرامكو السعودية<br>
                                    9:00 صباحًا إلى 4:30 مساء (الأحد- الخميس)</p><br><br>
                            </div>
                        </div>
                        <div v-if="selectedComponent === 1">
                            <div v-if="selectedLanguage === 'en'">
                                <p>Call Center:<br><strong><a href="tel:8001242229">800 124 2229</a></strong></p>
                                <p>From outside the Kingdom:<br><strong><a href="tel:+966112926666">(+966) 11 292
                                            6666</a></strong><br>
                                    &nbsp;</p><br><br>
                            </div>
                            <div v-if="selectedLanguage === 'ar'">
                                <p>من السعودية&nbsp;<br><strong><span class="en-ar"><a href="tel:8001242229">2229 124
                                                800</a></span></strong></p>

                                <p>من خارج المملكة:<br><strong><span class="en-ar"><a href="tel:+966112926666">6666 292 11
                                                (966+)</a></span></strong></p><br><br>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12"
                           lg="4"
                           md="4"
                           sm="12">
                        <div style="display: flex;align-items: center;gap: 7px;">
                            <span>
                                <svg style="width: 20px;margin-bottom: -3px;"
                                     width="19"
                                     height="14"
                                     viewBox="0 0 19 14"
                                     fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.6777 0H1.92773C1.62961 0.000791837 1.34399 0.119576 1.13318 0.330383C0.922372 0.54119 0.803526 0.826875 0.802734 1.125V12.308C0.803526 12.6061 0.922372 12.8918 1.13318 13.1026C1.34399 13.3134 1.62961 13.4322 1.92773 13.433H17.6777C17.9759 13.4322 18.2616 13.3134 18.4724 13.1026C18.6832 12.8918 18.8019 12.6061 18.8027 12.308V1.125C18.8019 0.826875 18.6832 0.54119 18.4724 0.330383C18.2616 0.119576 17.9759 0.000791837 17.6777 0ZM9.80273 8.15601L2.84875 1.13202H16.7557L9.80273 8.15601ZM1.87683 12.356V1.77802L9.40173 9.36102C9.50825 9.4663 9.65199 9.52533 9.80176 9.52533C9.95152 9.52533 10.0953 9.4663 10.2018 9.36102L17.7268 1.77802V12.358L1.87683 12.356Z"
                                          fill="#006FCF"></path>
                                </svg>
                            </span>
                            <b>{{ $t('Email Us') }}</b>
                        </div>

                    </v-col>
                    <v-col cols="12"
                           lg="8"
                           md="8"
                           sm="12"
                           style="overflow: auto;">
                        <div v-if="selectedComponent === 0">
                            <a
                               href="mailto:customerservice@americanexpress.com.sa">customerservice@americanexpress.com.sa</a>
                        </div>
                        <div v-if="selectedComponent === 1">
                            <a
                               href="mailto:membership.rewards@americanexpress.com.sa">membership.rewards@americanexpress.com.sa</a>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import store from '@/store';
import { mdiEyeOffOutline, mdiEyeOutline, mdiClose } from '@mdi/js';

export default {
    data: () => ({
        items: [
            {
                icon: 'mdi-forum',
                text: 'Customer Service',
                iconAr: 'mdi-chevron-left',
                icon2: 'mdi-chevron-right'
            },
            {
                icon: 'mdi-map-marker',
                text: 'Membership Rewards',
                iconAr: 'mdi-chevron-left',
                icon2: 'mdi-chevron-right'
            },
        ],
        selectedComponent: 0,
        selectedLanguage: 'en',
        icons: {
            mdiEyeOutline,
            mdiEyeOffOutline,
            mdiClose,
        },
    }),
    created()
    {
        store.subscribe(mutation =>
        {
            if (mutation.type === 'accounts/SET_LANGUAGE')
            {
                this.selectedLanguage = mutation.payload;
            }
        })
    },
    mounted()
    {
        let lang = localStorage.getItem('language')
        if (lang)
        {
            this.selectedLanguage = localStorage.getItem('language')
        }

    },
    methods: {
        showComponent(item, index)
        {
            this.selectedComponent = index;
        }
    },
}
</script>
<style scoped>
.pointer {
    cursor: pointer;
}

.text-white {
    color: white;
}

.selected {
    color: white !important;
    background-color: #016fd0;
}
</style>
